module.exports = __webpack_public_path__ + "static/img/img17.bb7ade7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img17.png
// module id = 1Sec
// module chunks = 1